export type Listener<T> = (value: T) => void;

export interface ReadonlySignal<T> {
    value: T;
    listen(listener: Listener<T>): VoidFunction;
}

export interface Signal<T> extends ReadonlySignal<T> {
    emit(value: T): void;
}

export function createSignal<T>(initial: T): Signal<T>;
export function createSignal<T>(): Signal<T | undefined>;
export function createSignal<T>(initial?: T): Signal<T | undefined> {
    let listeners: Listener<T | undefined>[] = [];
    let value: T | undefined = initial;

    return {
        get value() {
            return value;
        },

        emit(payload) {
            value = payload;
            for (const listener of listeners) {
                listener(payload);
            }
        },

        listen(listener) {
            listeners.push(listener);

            return () => {
                listeners = listeners.filter(fn => fn !== listener);
            };
        },
    };
}
